<template>
  <!-- Vertically centered scrollable modal -->
  <div>
    <form label-width="0px" class="demo-ruleForm needs-validation-update-password" novalidate>
      <div class="modal fade" id="updatePasswordModal" tabindex="-1" role="dialog" aria-labelledby="updatePasswordModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="staticBackdropLabel">{{$t('UpdatePasswordPage.UpdatePassword')}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="text-center pt-3 pb-3">
                {{$t('UpdatePasswordPage.Tips')}}
              </div>
              <div class="form-group row no-gutters col-12">
                <label class="col-12 col-md-3 offset-md-1" for="inputPasswordCurrent">{{$t('UpdatePasswordPage.CurrentPassword')}}</label>
                <div class="col-12 col-md-8">
                  <div style="height:60px;">
                    <input type="password" maxlength="128" v-model="currentPassword" required class="form-control" id="inputPasswordCurrent">
                    <div class="invalid-feedback">
                      {{$t('UpdatePasswordPage.ErrorPormpt')}}
                    </div>
                  </div>
                  <small>
                    <a href="javascript:void(0);" data-toggle="modal" data-target="#forgetPasswordModal">{{$t('forgotPassword.forgotPasswordText')}}</a>
                  </small>
                </div>
              </div>
              <div class="form-group row no-gutters col-12 pb-3">
                <label class="col-12 col-md-3 offset-md-1" for="newPassword">{{$t('UpdatePasswordPage.NewsPassword')}}</label>
                <div class="col-12 col-md-8">
                  <input type="password" maxlength="128" class="form-control" required v-model="newPassword" id="newPassword">
                  <div class="invalid-feedback">
                    {{$t('UpdatePasswordPage.ErrorPormptnewspad')}}
                  </div>
                </div>
              </div>
              <div class="form-group row no-gutters col-12 mb-0">
                <label class="col-12 col-md-3 offset-md-1" for="verifyPassword">{{$t('UpdatePasswordPage.VerifyPassword')}}</label>
                <div class="col-12 col-md-8">
                  <input type="password" maxlength="128" class="form-control" required v-model="verifyPassword" id="verifyPassword">
                  <div class="invalid-feedback">
                    {{$t('UpdatePasswordPage.ErrorPormptVerify')}}
                  </div>
                  <div class="invalid-feedback password-not-match" style="display:none">
                    {{$t('UpdatePasswordPage.notMatch')}}
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer pt-5 pb-3">
              <div class="col-6">
                <button type="button" class="btn btn-lg btn-outline-secondary" data-dismiss="modal">{{$t('UpdatePasswordPage.Cancelbtn')}}
                </button>
              </div>
              <div class="col-6 text-right">
                <button class="btn btn-lg btn-primary" @click="change">{{$t('UpdatePasswordPage.Changebtn')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <form label-width="0px" class="demo-ruleForm needs-validation-forget-password" novalidate>
      <div class="modal fade" id="forgetPasswordModal" tabindex="-1" role="dialog" aria-labelledby="forgetPasswordModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="forgetPasswordModalLabel">
                {{$t('forgotPassword.modalTitle')}}
              </h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="forgetEmail">{{$t('login.email')}}</label>
                <input class="form-control form-control-lg" v-model="forgetPasswordEmail" type="email" id="forgetEmail" required />
                <div class="invalid-feedback">
                  {{$t('login.emailRequired')}}
                </div>
              </div>
            </div>
            <div class="modal-footer pt-5 pb-5">
              <div class="col-6">
                <button type="button" class="btn btn-lg btn-outline-secondary" data-dismiss="modal">{{$t('modal.modalCancel')}}
                </button>
              </div>
              <div class="col-6 text-right">
                <button class="btn btn-lg btn-primary" type="submit" @click="forgetPassword">{{$t('TwiceVerification.modalSubmit')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<style />

<script type="text/javascript">
import { NmsClient, RestCfg } from '../../scripts/AllExport'
import crypto from 'crypto'
let updatePasswordType = 'user-setting-password'
let forgetPasswordReqType = 'user-forget-password'
export default {
  data: function () {
    return {
      currentPassword: '',
      newPassword: '',
      verifyPassword: ''
    }
  },
  mounted() {
    $('#updatePasswordModal').on('hidden.bs.modal', (event) => {
      this.currentPassword = ''
      this.newPassword = ''
      this.verifyPassword = ''
      if ($('.needs-validation-update-password')[0] !== undefined) {
        $('.needs-validation-update-password')[0].classList.remove('was-validated')
      }
      $('#verifyPassword').removeClass('password-invalid password-valid')
      $('#verifyPassword').parent().find('.password-not-match').css({'display': 'none'})
      $('#verifyPassword,#newPassword').unbind('input propertychange')
    })
    $('#forgetPasswordModal').on('hidden.bs.modal', (event) => {
      this.forgetPasswordEmail = ''
      if ($('.needs-validation-forget-password')[0] !== undefined) {
        $('.needs-validation-forget-password')[0].classList.remove('was-validated')
      }
    })
  },
  methods: {
    change() {
      let form = $('.needs-validation-update-password')[0]

      form.onsubmit = (event) => {
        event.preventDefault()
        if (this.checkpass(form) && form.checkValidity()) {
          NmsClient.send(
            RestCfg.POST,
            {
              'reqType': updatePasswordType,
              'password': this.createHash(this.currentPassword),
              'newPassword': this.createHash(this.verifyPassword)
            },
            this.updatePasswordResult,
            null
          )
        }
        form.classList.add('was-validated')
      }
    },
    updatePasswordResult(response) {
      this.$alert(this.$t('UpdatePasswordPage.Updatesucceeded'), this.$t('orderListPopup.Messgae'), {
        confirmButtonText: 'OK',
        lockScroll: false,
        closeOnClickModal: true,
        callback: action => {
          $('#updatePasswordModal').modal('hide')
        }
      })
    },
    forgetPassword() {
      let form = $('.needs-validation-forget-password')[0]

      form.onsubmit = (event) => {
        event.preventDefault()
        if (form.checkValidity()) {
          NmsClient.send(
            RestCfg.POST,
            {
              'reqType': forgetPasswordReqType,
              'email': this.forgetPasswordEmail,
              'type': 1
            },
            () => {
              this.$alert(this.$t('forgotPassword.sendEmailSuccess'), this.$t('forgotPassword.message'), {
                confirmButtonText: 'OK',
                lockScroll: false,
                closeOnClickModal: true,
                callback: action => {
                  $('#forgetPasswordModal').modal('hide')
                }
              })
            },
            null
          )
        }
        form.classList.add('was-validated')
      }
    },
    createHash(password) {
      // パスワードハッシュ化
      let md5 = crypto.createHash('md5')
      let md5Sum = md5.update(password)
      return md5Sum.digest('Base64')
    },
    checkpass(from) {
      let jqCheckPassword = $('#verifyPassword')
      $('#verifyPassword,#newPassword').off('input propertychange').on('input propertychange', () => {
        if (this.newPassword !== this.verifyPassword) {
          jqCheckPassword.removeClass('password-valid').addClass('password-invalid')
          if (this.verifyPassword === '') {
            jqCheckPassword.parent().find('.password-not-match').css({'display': 'none'})
            return
          }
          jqCheckPassword.parent().find('.password-not-match').css({'display': 'block'})
        } else {
          jqCheckPassword.parent().find('.password-not-match').css({'display': 'none'})
          if (this.verifyPassword === null || this.verifyPassword === '') return
          jqCheckPassword.removeClass('password-invalid').addClass('password-valid')
        }
      })
      if (!from.checkValidity()) {
        return
      }
      if (this.newPassword !== this.verifyPassword) {
        jqCheckPassword.removeClass('password-valid').addClass('password-invalid')
        jqCheckPassword.parent().find('.password-not-match').css({'display': 'block'})
        return false
      } else {
        jqCheckPassword.removeClass('password-invalid').addClass('password-valid')
        return true
      }
    }
  }
}
</script>
<style scoped>
.form-group {
    margin-bottom: 1rem;
    height: 85px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/update-password.vue